import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

/**
 * Solid content surface — white paper on cream, ink-500 on dark. design.md:
 * cards are solid (NEVER glass), shadow on light, hairline border on dark.
 * Press lifts to shadow-md, no scale.
 */
export function Card({
  className,
  interactive,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement> & { interactive?: boolean }) {
  return (
    <div
      className={cn(
        "rounded-card bg-paper border border-transparent dark:border-hairline shadow-sm dark:shadow-none",
        interactive &&
          "cursor-pointer transition-shadow duration-200 ease-out-soft hover:shadow-md dark:hover:border-white/10",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  title,
  eyebrow,
  action,
  className,
}: {
  title: ReactNode;
  eyebrow?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex items-start justify-between gap-3 p-5 pb-3", className)}>
      <div>
        {eyebrow && <p className="eyebrow mb-1.5">{eyebrow}</p>}
        <h3 className="text-[15px] font-semibold tracking-tight text-ink-strong">{title}</h3>
      </div>
      {action}
    </div>
  );
}
